import React, { FC } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import ctaTypes from '../../../../../enums/CTA.enums';
import { appendToUrlPath } from '../../../../../utils/link.utils';
import CTA from '../../../CTA';
import { TCtaBlockProps } from '../../types/seriesListing.types';

const CtaBlock: FC<WithTranslation & TCtaBlockProps> = (props) => {
  const { titleUrl, baseUrl, t } = props;
  if (!titleUrl) return null;
  return (
    <CTA type={ctaTypes['secondaryBlack']} href={appendToUrlPath(baseUrl || '', titleUrl)}>
      {t('cnhi-showMoreButton')}
    </CTA>
  );
};

export default withTranslation()(CtaBlock);
